import { ComponentDataDestService } from "../component-data-dest.service";
import { catchError, map } from 'rxjs';
import { RlsPolicy } from '../../../models/rls/RlsPolicy.model';
import { RlsPolicyDTO } from '../../../dto/rls/policy.dto';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';

export function add_rls_policy(componentDataDestService: ComponentDataDestService, componentDataSourceService: ComponentDataSourceService, data: any) {
    
    // Convert incoming data to model
    const policyModel = new RlsPolicy(
        data.table_name,
        data.policy_name,
        data.roles || [],
        data.cmd.toUpperCase(),
        data.using_expr || 'false',
        data.with_check_expr || ''
    );

    // Convert model to DTO
    const policyDTO: RlsPolicyDTO = RlsPolicy.convertToDTO(policyModel);

    // Send DTO to API and update store data
    const request$ = componentDataDestService.http.post(`${environment.apiUrl}/rls/policies`, policyDTO).pipe(
        catchError(error => {
            console.error("[add_rls_policy] Error:", error);
            throw error;
        }),
        map(response => {
            return response;
        })
    );

    // Use the helper function to handle store update
    componentDataSourceService.updateStoreData(request$, 'rls_policies').subscribe({
        error: (error) => console.error('[add_rls_policy] Store update error:', error)
    });
} 